import React from 'react'

import './styles.css'
import { MainLayout } from '../../components'
import { Countries } from './components'

export default () => {
    return (
        <MainLayout
            pageContent={<Countries/>}
        />
    )
}